import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import EmailPasswordLoginForm from '@/components/forms/email-password-login-form'
import { AuthSplitLayout } from '@/components/layout/auth-split-layout'

export const Route = createFileRoute('/login/')({
  component: LoginPage,
})

function LoginPage() {
  const { t } = useTranslation()

  return (
    <AuthSplitLayout>
      <div className="flex-1 flex flex-col justify-center w-full md:flex-none md:mb-6 md:space-y-6 ">
        <div className="flex flex-col gap-y-3">
          <h1 className="heading-1 text-center">{t('landingPage.title')}</h1>
          <p className="body-1 text-text-secondary text-center">{t('landingPage.description')}</p>
        </div>
      </div>

      <div className="w-full gap-6 flex flex-col">
        <EmailPasswordLoginForm />
      </div>
    </AuthSplitLayout>
  )
}
